import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Image from '../../images/hero-img.png'
import Image2 from '../../images/events_img3.png'
import Image3 from '../../images/customize_bg.png'
import Image4 from '../../images/faq_img.png'
import Image5 from '../../images/sheild_img.png'
import Image6 from '../../images/contact_img.png'
import SectionName from '../../components/SectionName';
import { FaCheckCircle } from "react-icons/fa";
import { AiOutlineUser } from "react-icons/ai";
import { BsShop } from "react-icons/bs";
import { TfiMedall } from "react-icons/tfi";
// import { IoIosArrowDroprightCircle } from "react-icons/io";
import Accordion from 'react-bootstrap/Accordion';
import { MdSportsSoccer } from "react-icons/md";

const Home = () => {
    // const [selected, setSelected] = useState("");
    return (
        <>

            <section className='hero_section_bg '>
                <Container>
                    <Row>
                        <Col md={6}>
                            <div className="hero_text">
                                {/* <span>welcome to Our Website</span> */}
                                <h1>Comprehensive coverage for every occasion</h1>
                                <p>Ensure your event is covered against accidents or unexpected incidents.</p>
                                <button className='custom_btn'>
                                    <Link to='/form-links'>get started</Link>
                                </button>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="hero_img">
                                <img src={Image} alt="" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='events_insure_section'>
                <Container fluid>
                    <SectionName title="What makes us different?" sub_title="all events insure"
                        description="We pride ourselves in being efficient, professional, and personal while offering you the best insurance solution that fits your needs." />
                    <Row className='align-items-end pad__100'>
                        <Col md={7}>
                            <div className="events_insure_img">
                                <img src={Image2} alt="img" />
                            </div>
                        </Col>

                        <Col md={5}>
                            <div className="events_insure_content">
                                <h1>A simplified, personalized insurance experience</h1>
                                <p>Our team of experienced professionals is passionate about delivering reliable and customized insurance solutions, allowing you to focus on making your event a success.</p>
                                <div className="events_option">
                                    <ul>
                                        <li>
                                            <h5>Competitive Rates</h5>
                                            {/* <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p> */}
                                            <span><FaCheckCircle /></span>
                                        </li>
                                        <li>
                                            <h5>Flexible Options</h5>
                                            {/* <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p> */}
                                            <span><FaCheckCircle /></span>
                                        </li>
                                        <li>
                                            <h5>Excellent Customer Service</h5>
                                            {/* <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p> */}
                                            <span><FaCheckCircle /></span>
                                        </li>
                                        <li>
                                            <h5>Fast and Efficient Process</h5>
                                            {/* <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p> */}
                                            <span><FaCheckCircle /></span>
                                        </li>
                                    </ul>
                                </div>
                                <button className='custom_btn'>
                                    <Link to='/form-links'>get started</Link>
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='services_section pad__150'>
                <Container>
                    <SectionName title="Event insurance tailored just for you" sub_title="all events insure"
                        description="Coverage for weddings, parties, and more. Whether it's a private party or a large public event, we have you covered." />
                    <Row className='mt-5'>
                        <Col md={3}>
                            <div className="services_card">
                                <div className="services_icon">
                                    <AiOutlineUser />
                                </div>
                                <div className="services__content__box">
                                    <h2>Personal</h2>
                                    <strong>Safeguard your special day</strong>
                                    <p>
                                        Protect your special day with comprehensive coverage for personal events and celebrations.
                                    </p>
                                </div>
                            </div>
                        </Col>

                        <Col md={3}>
                            <div className="services_card">
                                <div className="services_icon">
                                    <TfiMedall />
                                </div>
                                <div className="services__content__box">
                                    <h2>Professional</h2>
                                    <strong>Custom coverage for corporate events</strong>
                                    <p>
                                        Safeguard your success with tailored insurance for exhibitions and professional events.
                                    </p>
                                </div>
                            </div>
                        </Col>

                        <Col md={3}>
                            <div className="services_card">
                                <div className="services_icon">
                                    <MdSportsSoccer />
                                </div>
                                <div className="services__content__box">
                                    <h2>Sports</h2>
                                    {/* <strong>Lorem Ipsum</strong> */}
                                    <p>Keep the game on—reliable insurance for sporting events of all sizes.</p>
                                </div>
                            </div>
                        </Col>

                        <Col md={3}>
                            <div className="services_card">
                                <div className="services_icon">
                                    <BsShop />
                                </div>
                                <div className="services__content__box">
                                    <h2>Vendor</h2>
                                    {/* <strong>Lorem Ipsum</strong> */}
                                    <p>Secure your stall, sell with confidence—coverage designed for vendors at any event.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='customize_section'>
                <Container>
                    <Row className='align-items-center'>
                        <Col md={7}>
                            <div className="customize_content mb-5">
                                <span>all events insure</span>
                                <h1>get your customize plans</h1>
                                <p>
                                    Introducing your go-to event insurance partner, offering seamless protection for Personal milestones like weddings, Professional events such as trade shows, exciting Sport competitions, and lively Vendor stalls. Our expertly crafted coverage adapts to your unique needs, ensuring everything from heartfelt celebrations to high-stakes exhibitions runs smoothly. With us, you’re free to plan confidently, knowing every event—big or small—is fully secured.
                                    <br />
                                    <br />
                                    Planning a wedding? Hosting an industry expo? Running a sports tournament? Setting up a vendor stall? Life’s unpredictable, but your event doesn’t have to be. Our tailored insurance covers Personal celebrations, Professional showcases, Sport thrills, and Vendor ventures—keeping cancellations, damages, and surprises at bay. Secure your event in just a few clicks.
                                    <br />
                                    <br />
                                    <strong>Plan Boldly. We’ve Got Your Back.</strong>
                                    <br />
                                    Unexpected setbacks shouldn’t ruin your event. Whether it’s a Personal milestone, a Professional breakthrough, a Sport showdown, or a Vendor spotlight, our event insurance delivers peace of mind with coverage that fits. Affordable rates, fast claims, total protection.
                                </p>
                                <button className='custom_btn_2'>
                                    <Link to='/form-links'>get started</Link>
                                </button>
                            </div>
                        </Col>
                        <Col md={5} style={{ margin: "auto 0 0 0" }}>
                            <div className="customize_img">
                                <img src={Image3} alt="img" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* <section className='offer_section pad__100'>
                <Container>
                    <SectionName title="Offering our Best Plan for your Insurance Objective" sub_title="all events insure" />
                    <Row className='pt-5'>
                        <Col md={4}>
                            <div className="offer_card">
                                <h3>Baby Shower</h3>
                                <p>Lorem ipsum dolor sit amet cons adipiscing elit ut elit tellus luctus nec.</p>
                                <div class="pricing">
                                    <span class="currency">$</span>
                                    <span class="price">29</span>
                                    <span class="duration">/monthly</span>
                                </div>
                                <hr />
                                <div class="offer_description">
                                    <ul>
                                        <li>Comprehensive coverage</li>
                                        <li>Quick claims processing</li>
                                        <li>24/7 customer support</li>
                                        <li>Accident forgiveness</li>
                                        <li>Flexible payment options</li>
                                        <li>Multi-policy discounts</li>
                                    </ul>
                                </div>
                                <button className='custom_btn'>
                                    <Link to='#'>Buy Now <IoIosArrowDroprightCircle /></Link>
                                </button>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="offer_card">
                                <h3>Annivarsary Party</h3>
                                <p>Lorem ipsum dolor sit amet cons adipiscing elit ut elit tellus luctus nec.</p>
                                <div class="pricing">
                                    <span class="currency">$</span>
                                    <span class="price">59</span>
                                    <span class="duration">/monthly</span>
                                </div>
                                <hr />
                                <div class="offer_description">
                                    <ul>
                                        <li>Comprehensive coverage</li>
                                        <li>Quick claims processing</li>
                                        <li>24/7 customer support</li>
                                        <li>Accident forgiveness</li>
                                        <li>Flexible payment options</li>
                                        <li>Multi-policy discounts</li>
                                    </ul>
                                </div>
                                <button className='custom_btn'>
                                    <Link to='#'>Buy Now <IoIosArrowDroprightCircle /></Link>
                                </button>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="offer_card">
                                <h3>Softball</h3>
                                <p>Lorem ipsum dolor sit amet cons adipiscing elit ut elit tellus luctus nec.</p>
                                <div class="pricing">
                                    <span class="currency">$</span>
                                    <span class="price">79</span>
                                    <span class="duration">/monthly</span>
                                </div>
                                <hr />
                                <div class="offer_description">
                                    <ul>
                                        <li>Comprehensive coverage</li>
                                        <li>Quick claims processing</li>
                                        <li>24/7 customer support</li>
                                        <li>Accident forgiveness</li>
                                        <li>Flexible payment options</li>
                                        <li>Multi-policy discounts</li>
                                    </ul>
                                </div>
                                <button className='custom_btn'>
                                    <Link to='#'>Buy Now <IoIosArrowDroprightCircle /></Link>
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}

            {/* <section className='our_events_section'>
                <Container>
                    <Row className='align-items-center'>
                        <Col md={6}>
                            <div className="customize_content">
                                <span>all events insure</span>
                                <h1>Our Events</h1>
                                <p>At All Events Insure, we provide a comprehensive suite of event insurance options designed to safeguard your event from potential risks and liabilities.</p>
                                <button className='custom_btn_2'>
                                    <Link to='#'>get started</Link>
                                </button>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="our_events_box">
                                <Row className='align-items-center'>
                                    <Col md={5}>
                                        <h5 className='mb-5'>Bartender at the Event</h5>
                                        <h5>Religious Assembly</h5>
                                    </Col>
                                    <Col md={5}>
                                        <h5 className='our_events_box_right'>Soccer-YOUTH ONLY</h5>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}

            <section className='faq_section pad__120'>
                <Container fluid>
                    <Row>
                        <Col md={6}>
                            <div className="faq_content">
                                <h1>frequently asked questions</h1>
                                <p>Our team of experienced professionals is passionate about delivering reliable and customized insurance solutions, allowing you to focus on making your event a success.</p>
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Place Your Ttile Here</Accordion.Header>
                                        <Accordion.Body>
                                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                                            when an unknown printer took a galley of type and scrambled it to make
                                            a type specimen book
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Place Your Ttile Here</Accordion.Header>
                                        <Accordion.Body>
                                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                                            when an unknown printer took a galley of type and scrambled it to make
                                            a type specimen book
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Place Your Ttile Here</Accordion.Header>
                                        <Accordion.Body>
                                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                                            when an unknown printer took a galley of type and scrambled it to make
                                            a type specimen book
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>Place Your Ttile Here</Accordion.Header>
                                        <Accordion.Body>
                                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                                            when an unknown printer took a galley of type and scrambled it to make
                                            a type specimen book
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="faq_img">
                                <img src={Image4} alt="" />
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <div className="sheild_section">
                        <div className="sheild_img">
                            <img src={Image5} alt="img" />
                        </div>
                        <div className="sheild_content">
                            <h3>Ready to insure?</h3>
                            <p>With our efficient systems and experienced staff, we ensure a hassle-free experience with quick turnarounds.</p>
                        </div>
                        <div className="custom_btn">
                            <Link to='/form-links'>GET STARTED</Link>
                        </div>
                    </div>
                </Container>
            </section>

            <section className='contact_section'>
                <Container>
                    <div className="contact_us">
                        <Row>
                            <Col md={6}>
                                <div className="contact_input">
                                    <form action="">
                                        <Row>
                                            <Col md={6} className='mb-4'>
                                                <input type="text" name='name' placeholder="Name" className='form-control' />
                                            </Col>
                                            <Col md={6} className='mb-4'>
                                                <input type="email" name='email' placeholder="Email" className='form-control' />
                                            </Col>
                                            <Col md={12} className='mb-4'>
                                                <textarea name='message' rows={8} placeholder="Your Message" className='form-control' />
                                            </Col>
                                        </Row>
                                        <button className='custom_btn_1'>GET A QUOTE</button>
                                    </form>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="contact_content">
                                    <h1>Contact Us</h1>
                                    <ul className='contact_list'>
                                        <li><Link to="tel:(833) 320-1199">(833) 320-1199</Link></li>
                                        <li>sales@alleventsinsure.com</li>
                                    </ul>
                                    <p>
                                        We prioritize exceptional customer service, providing personalized
                                        support and prompt responses throughout the process.
                                    </p>
                                    <div className="contact_img">
                                        <img src={Image6} alt="" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>

        </>
    )
}

export default Home